var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "View") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "View"
  }, /*#__PURE__*/React.createElement("g", {
    id: "View-2",
    "data-name": "View"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.9978,73.8247a182.1789,182.1789,0,0,0-182.1753,182.18c0,100.6083,81.567,182.1708,182.1753,182.1708s182.18-81.5625,182.18-182.1708A182.1828,182.1828,0,0,0,255.9978,73.8247ZM378.4472,261.814c-2.2239,2.8476-55.2212,69.68-122.7041,69.68-67.491,0-120.4848-66.8322-122.7087-69.68l-4.5477-5.8185,4.5477-5.8176c2.2239-2.8395,55.2177-69.68,122.7087-69.68,67.4829,0,120.48,66.84,122.7041,69.68l4.5441,5.8176Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.7431,199.4035c-47.4606,0-88.884,41.08-102.8232,56.592,13.9311,15.4953,55.3581,56.5929,102.8232,56.5929,47.4524,0,88.8794-41.08,102.8231-56.5929C344.636,240.5011,303.1955,199.4035,255.7431,199.4035Zm-.0045,98.8587a42.2577,42.2577,0,1,1,42.2621-42.2667A42.2651,42.2651,0,0,1,255.7386,298.2622Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/ViewIcon.fb506589dc8f0600a183c1cd06f3b6cc.svg";
export { ForwardRef as ReactComponent };